import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShieldDoneBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.357 5.137C18.654 4.431 13.027 2.5 12 2.5c-1.026 0-6.653 1.931-7.357 2.637-.56.562-.552.996-.508 3.397.018.974.042 2.3.042 4.136 0 6.407 7.601 8.785 7.678 8.808a.48.48 0 0 0 .29 0c.077-.023 7.68-2.401 7.68-8.808 0-1.831.023-3.155.041-4.128.043-2.407.05-2.842-.509-3.405"
      clipRule="evenodd"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      d="m11.855 14.05 3.722-3.72a.75.75 0 1 0-1.061-1.061l-3.19 3.189-1.275-1.277a.75.75 0 1 0-1.062 1.058l1.805 1.81a.747.747 0 0 0 1.06 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgShieldDoneBulk);
export default ForwardRef;
